import { Navigate, useSearchParams } from "react-router-dom";
import { N2TargetPage } from "@/features/n2/pages/N2TargetPage";
import { parseIndicateurIdParam } from "@/features/n2/mappers/n2-params";

/**
 * `/n2` detail route. Bare `/n2` redirects to the indicators catalog —
 * detail requires `?indicateurId=`.
 */
export function N2Page() {
  const [searchParams] = useSearchParams();
  const indicateurId = parseIndicateurIdParam(searchParams.get("indicateurId"));

  if (indicateurId === null) {
    return <Navigate to="/indicators" replace />;
  }

  return <N2TargetPage indicateurId={indicateurId} />;
}
